import React from 'react';

interface IconProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const IsCheckedIcon = ({ fill = '#28B57A', width = 12, height = 8, ...rest }: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 12 9"
        fill="none"
        {...rest}
    >
        <path
            d="M3.88484 8C3.68648 8.00035 3.49001 7.96247 3.3067 7.88853C3.12339 7.8146 2.95686 7.70605 2.81669 7.56914L0 4.82191L0.712103 4.12675L3.52879 6.87448C3.62323 6.96658 3.7513 7.01832 3.88484 7.01832C4.01838 7.01832 4.14645 6.96658 4.24089 6.87448L11.2879 0L12 0.694669L4.953 7.56914C4.81282 7.70605 4.64629 7.8146 4.46299 7.88853C4.27968 7.96247 4.0832 8.00035 3.88484 8Z"
            fill={fill}
        />
    </svg>
);
